import Vue from "vue";
import moment from "moment";
import ApiService from "../../../../../services/api";
import gridbase from "../../../../../components/gridComponentBase.js";
import { mapGetters } from "vuex";
import helpers from "../../../../../shared/fleetbox-helpers";
import { bus } from "../../../../../main";

export default {
	extends: gridbase,
	props: {
		filters: Array
	},
	data: function() {
		return {
			columns: [
				{
					field: "diagnosis_data",
					title: "",
					configId: "",
					width: "50",
					headerCell: "myHeaderTemplate",
					cell: "myImageCellTemplate",
					editable: false,
					sortable: false,
					filterable: false,
					configByPass: true,
					order: 0
				},
				{
					field: "number_plate",
					configId: "number_plate",
					title: "targa",
					width: "100",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "vehicle_code",
					configId: "vehicle_code",
					title: "codice",
					width: "130",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "vehicle_name",
					title: "veicolo",
					configId: "vehicle_name",
					width: "290",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "driver_name",
					title: "conducente",
					configId: "driver_name",
					width: "200",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "division_name",
					title: "divisione",
					configId: "division_name",
					width: "200",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					permit: "hasDivisions",
					sortable: false
				},
				{
					field: "event_date",
					configId: "event_date",
					title: "data",
					width: "200",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "datetime",
					filterable: false,
					sortable: false
				},
				{
					field: "data_category_description",
					configId: "description",
					title: "evento",
					width: "480",
					headerCell: "myDescriptionEventHeaderTemplate",
					format: "",
					sortable: false,
					filterable: true
				},
				{
					field: "main_category",
					configId: "category",
					title: "evento",
					width: "200",
					headerCell: "myCategoryHeaderTemplate",
					format: "",
					sortable: false,
					filterable: true
				},
				{
					field: "latitude",
					configId: "latitude",
					title: "posizione",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "",
					cell: "positionCoordinates",
					filterable: false,
					sortable: false
				},
				{
					field: "longitude",
					configId: "longitude",
					title: "posizione",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "",
					cell: "positionCoordinates",
					filterable: false,
					sortable: false
				},
				{
					field: "value",
					configId: "value",
					title: "Valore",
					headerCell: "myHeaderTemplate",
					format: "",
					width: "200",
					filterable: false,
					sortable: false
				},
				{
					field: "parameter",
					configId: "parameter",
					title: "Parametro",
					width: "350",
					headerCell: "myHeaderTemplate",
					sortable: false,
					filterable: false,
					cell: "myCellTemplate"
				},
				{
					field: "um",
					configId: "unit",
					title: "UM",
					headerCell: "myHeaderTemplate",
					format: "",
					width: "80",
					filterable: false,
					sortable: false
				},
			],

			config: [],
			items: [],

			eventsFilter: [],
			eventsFilterSelected: [],
			eventsForQuery: [],
			totalEvents: [],

			categoryFilter: [],
			categoryFilterSelected: [],

			vehicleIdFilterField: "number_plate",
			vehicleIdFilterFieldFormatted: "vehicles",
			vehicleIdFilterFieldColumn: "number_plate",

			hasDiagnosticDataPermission: false,
			hasDivisions: false
		};
	},

	created() {
		this.hasSelectedMode = true;
		this.query.pageSize = 25;
		this.take = 25;

		if (this.settings && this.settings.defaultPageSize && this.settings.defaultPageSize > 0) {
			this.query.pageSize = parseInt(this.settings.defaultPageSize);
			this.take = parseInt(this.settings.defaultPageSize);
		}

		if (this.settings && this.settings.hasDivisions) this.hasDivisions = true;

		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;
		this.vehicleIdFilterFieldFormatted = "vehicles";
		if (this.vehicleIdFilterField == "code") {
			this.vehicleIdFilterFieldFormatted = "vehicleCodes";
			this.vehicleIdFilterFieldColumn = "vehicle_code";
		}

		if (this.scopes && this.scopes.length > 0) {
			this.hasDiagnosticDataPermission = this.scopes.some(item => {
				return item == "TRIPS_DIAGNOSTIC_DATA";
			});
		}
	},
	mounted() {
		this.getConfig();
		this.getAllEvents();
	},
	watch: {
		// filters: {
		// 	handler: function() {
		// 		this.skip = 0;
		// 		this.query.page = 0;
		// 		this.getData();
		// 	},
		// 	deep: true
		// },
		categoryFilterSelected: function(newValue, oldValue) {
			var self = this;
			if (newValue && newValue.length > 0) {
				self.eventsFilter = [];
				for (var i = 0; i < newValue.length; i++) {
					var cat = newValue[i];
					var events = self.totalEvents.filter(function(item) {
						return item.category_key == cat;
					});

					self.eventsFilter = self.eventsFilter.concat(events);
				}

				self.eventsFilter = self._.sortBy(self.eventsFilter, function(item) {
					return item.id;
				});
			} else {
				this.eventsFilter = this.totalEvents;
			}

			this.eventsFilterSelected = [];
		}
	},
	methods: {
		applyReportFilter() {
			this.skip = 0;
			this.query.page = 0;
			this.getData();
		},
		goToDiagnosticData(number_plate, vehicle_id, diagnosisId, driver, diagnosisDate) {
			if (this.hasDiagnosticDataPermission) {
				var startDateFilter = null;

				var anomalyType = [];
				if (this.filters && this.filters.length > 0) {
					let filter = this.filters.find(function(item) {
						return item.id == "diagnosis-type";
					});

					if (filter) {
						if (filter.value.anomaly) anomalyType.push("anomaly_event");
						if (filter.value.information) anomalyType.push("info_event");
					}
				}

				var date = moment(diagnosisDate);
				var now = moment();

				var diff = now.diff(date, "days");
				if (diff == 0) {
					this.$router.push({
						name: "TRIPS_DIAGNOSTIC_DATA",
						query: {
							vehicleId: number_plate,
							diagnosisId: diagnosisId,
							driver: driver,
							startDay: date.utc().format(),
							code: vehicle_id,
							anomalyType: anomalyType
						}
					});
				} else {
					startDateFilter = date.startOf("day");
					this.$router.push({
						name: "TRIPS_DIAGNOSTIC_DATA",
						query: {
							vehicleId: number_plate,
							diagnosisId: diagnosisId,
							driver: driver,
							startDay: startDateFilter.utc().format(),
							code: vehicle_id,
							anomalyType: anomalyType
						}
					});
				}
			}
		},
		removeFilterHandler(e) {
			if (e.filterable) {
				this.skip = 0;
				this.query.page = 0;

				if (e.field == "data_category_description") {
					this.eventsFilterSelected.splice(0, this.eventsFilterSelected.length);
				} else if (e.field == "main_category") {
					this.categoryFilterSelected.splice(0, this.categoryFilterSelected.length);
					this.eventsFilterSelected.splice(0, this.eventsFilterSelected.length);
				}

				this.getData();
			}
		},
		filterHandler(e) {
			if (e.filterable) {
				this.skip = 0;
				this.query.page = 0;
				this.getData();
			}
		},
		getAllEvents() {
			var self = this;
			ApiService.getVehicleEventsData("diagnosis").then(res => {
				//EVENTS
				self.eventsForQuery = res
					.filter(function(item) {
						return item.description && item.description.length > 0;
					})
					.map(function(item) {
						return {
							id: item.description.toLowerCase(),
							value: item.description.toLowerCase(),
							queryValue: `${item.box_payload_id}${item.box_type_id ? "_" + item.box_type_id : ""}${item.box_cat_id ? "_" + item.box_cat_id : ""}`,
							category_key: item.category_key
						};
					});

				for (var i = 0; i < self.eventsForQuery.length; i++) {
					var evt = self.eventsForQuery[i];
					var existsEvent = self.eventsFilter.findIndex(item => {
						return item.id == evt.id;
					});
					if (existsEvent < 0) {
						self.eventsFilter.push(evt);
					}
				}

				self.eventsFilter = self._.sortBy(self.eventsFilter, function(item) {
					return item.id;
				});

				self.totalEvents = self.eventsFilter;

				//CATEGORY
				self.categoryFilter = res
					.filter(function(item) {
						return item.category_key && item.category_key.length > 0;
					})
					.map(function(item) {
						return {
							id: item.category_key.toLowerCase(),
							value: item.category_key.toLowerCase()
						};
					});

				self.categoryFilter = self._.uniqBy(self.categoryFilter, "id");

				self.categoryFilter = self._.sortBy(self.categoryFilter, function(item) {
					return item.id;
				});
			});
		},
		formattedCoordinates(current_position, typeCoord) {
			if (current_position && current_position.lat && current_position.lon) {
				var tc = typeCoord.substring(0, 3);
				return helpers.formatCoordinate(current_position[tc], tc);
			}
			return null;
		},
		getConfig: function() {
			var self = this;
			ApiService.getViewConfig("fleerun_report_diagnosis")
				.then(res => {
					self.config = res;
					self.setConfigColumns();
				})
				.finally(res => {
					self.getData();
				});
		},
		setConfigColumns() {
			var self = this;
			if (self.config && self.config.length > 0) {
				var orderedConfigColumn = self._.orderBy(self.config, "order", "asc");

				orderedConfigColumn.forEach(column => {
					var defColumn = self.columns.find(function(f) {
						return f.configId === column.field;
					});

					if (defColumn && column.enabled && (!defColumn.permit || self[defColumn.permit])) {
						defColumn.title = column.label;

						self.columnsToShow.push(defColumn);
					}
				});

				if (self.columnsToShow.length > 0) {
					var columnsByPassConfig = self._.filter(self.columns, function(item) {
						return item.configByPass;
					});

					for (var i = 0; i < columnsByPassConfig.length; i++) {
						var index = columnsByPassConfig[i].order || 0;
						self.columnsToShow.splice(index, 0, columnsByPassConfig[i]);
					}
				}

				self.dataReady = true;
			}
		},
		sortChangeHandler: function(e) {
			this.sort = e.sort;
			this.getData();
		},
		pageChangeHandler: function(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;

			if (this.skip === 0) {
				this.query.page = 0;
			}
			this.query.page = this.skip / this.take;

			this.getData();
		},
		downloadXlsx: function(type) {
			var self = this;
			var data = this.getRequestData();
			if (type == "csv") data["format"] = "csv";
			ApiService.exportChartXlsx("diagnosis", data).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Diagnosi.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		getData: function() {
			var self = this;

			this.$emit("on-loading", true);

			var data = this.getRequestData();

			ApiService.getDiagnosticReportData(data).then(res => {
				self.items = res.items.map(a => {
					return {
						id: a.id,
						trip_id: a.trip_id,
						event_date: a.event_date,
						box_serial_number: a.box_serial_number,
						number_plate: a.number_plate,
						vehicle_id: a.vehicle_id,
						vehicle_name: a.vehicle_name,
						driver_id: a.driver_id,
						driver_name: a.driver_name,
						division_name: a.division_name,
						vehicle_code: a.vehicle_code,
						type: a.type,
						subtype: a.subtype,
						icon: a.icon,
						car_gear_position_type: a.car_gear_position_type,
						type_name: a.type_name,
						description: a.description,
						timestamp: a.timestamp,
						mas: a.mas,
						speed: a.speed,
						position: a.position,
						position_name: a.position_display_name,
						drive_direction: a.drive_direction,
						data_category_description: a.description,
						data: a.data,
						main_category: a.main_category,

						//custom field
						diagnostic_description: a.data && a.data.category_description ? a.data.category_description : "",
						value: a.data && a.data.value ? a.data.value : "",
						um: a.data && a.data.unit ? a.data.unit : "",
						event_date_date: self.$options.filters.dateToString(a.event_date),
						event_date_time: self.$options.filters.timeToString(a.event_date),
						parameter: a.data && a.data.parameter ? a.data.parameter : "",
					};
				});

				self.total = res.totalCount;

				self.$emit("on-loading", false);
			});
		},
		getRequestData() {
			var self = this;
			var data = {};

			if (this.sort && this.sort.length > 0) {
				var sortParam = "";
				for (var i = 0; i < this.sort.length; i++) {
					if (i > 0) sortParam += ",";

					var fieldAndDir = this.sort[i];
					sortParam += `${fieldAndDir.field}|${fieldAndDir.dir}`;
				}

				data["sort"] = sortParam;
			}

			if (this.query.page) {
				data["page"] = this.query.page;
			}

			if (this.query.pageSize) {
				data["pageSize"] = this.query.pageSize;
			}

			if (this.filters && this.filters.length > 0) {
				this.filters.forEach(element => {
					switch (element.id) {
						case "timerange":
							data["dateRange.From"] = moment(element.value.startRange)
								.utc()
								.format();
							data["dateRange.To"] = moment(element.value.endRange)
								.utc()
								.format();
							break;
						case "divisions":
							if (element.value) {
								data["division"] = element.value;
							}
							break;
						case "groups":
							if (element.value && element.value != -1) {
								data["group"] = element.value;
							}
							break;
						case "vehicles":
							if (element.value && element.value.length > 0) {
								for (var j = 0; j < element.value.length; j++) {
									var field = `${self.vehicleIdFilterFieldFormatted}[${j}]`;
									var value = element.value[j];

									data[field] = value;
								}
							}
							break;
						case "drivers":
							if (element.value) {
								data["driver"] = element.value;
							}
							break;
						case "diagnosis-type":
							var types = [];
							if (element.value.anomaly) types.push("anomaly_event");
							if (element.value.information) types.push("info_event");
							if (element.value.information == false && element.value.anomaly == false) {
								types.push("anomaly_event");
								types.push("info_event");
							}

							if (types.length > 0) {
								data["types"] = types;
							}
							break;
						default:
							break;
					}
				});
			}

			var evtForQuery = [];
			for (var i = 0; i < this.eventsFilterSelected.length; i++) {
				var evtSelected = this.eventsFilterSelected[i];
				var evts = this.eventsForQuery.filter(item => {
					return item.id == evtSelected;
				});

				if (evts && evts.length > 0) evtForQuery = evtForQuery.concat(evts);
			}
			if (evtForQuery.length > 0) {
				data.eventKey = evtForQuery.map(item => {
					return item.queryValue;
				});
			}

			if (this.categoryFilterSelected) data["categoryKey"] = this.categoryFilterSelected;

			return data;
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		}
	},
	computed: {
		...mapGetters(["settings", "scopes"])
	}
};
